<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol >
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol
                    class="d-flex justify-content-end"
                >
                    <CButton            
                        class="button shadow create-button"
                        :title="$t('add_field')"
                        @click="
                            $router.push({
                                name: 'add_field'
                            })
                        "
                    >
                        <span class="button__icon text-white-50">
                            <CIcon :content="$options.icons.cilPlus"/>
                        </span>            
                        <span class="button__text"> {{ $t("add_field") }} </span>
                    </CButton>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.fields.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.fields.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="tables.fields.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.fields.rows"
                                    v-bind="tables.fields"
                                >
                                    <template #id="{ item }" >
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>
                                    <template #file_name="{ item }" >
                                        <td>
                                            <a :href="item.file_url">
                                                {{ (item.file_name) ? item.file_name:'' }}
                                            </a>
                                        </td>
                                    </template>
                                    <template #activity="{ index }">
                                        <td class="text-center">
                                            <CSpinner grow :color="activity[index]" size="sm" />
                                        </td>
                                    </template>
                                    
                                    <template #options="{ item }">
                                        <td class="py-2">
                                            
                                            <CButton
                                                color="primary"
                                                class="mx-1"
                                                square
                                                :title="$t('edit_field')"
                                                size="sm"
                                                @click="
                                                    $router.push({
                                                        name: 'edit_field',
                                                        query: { uuid: item.uuid },
                                                    })
                                                "
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilSettings"/>
                                            </CButton>

                                            <CButton
                                                color="danger"
                                                class="mx-1"
                                                square
                                                :title="$t('delete_field')"
                                                size="sm"
                                                @click="deleteField(item.uuid)"
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilTrash"/>
                                            </CButton>
                                        </td>
                                    </template>
                                    
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.fields.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.fields.page"
                                        :pages="tables.fields.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.fields.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import FilterDate from "~/components/FilterDate";
import { cilPlus, cilSettings, cilReload, cilPencil, cilChart , cilTrash, cilArrowThickFromRight, cilMediaPlay, cilMediaStop } from '@coreui/icons';
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js';
import FieldsTable from './config/tables/fields.js';
export default {
    name:"FieldsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop
    },
    data(){
        return{
            tables:{
                fields:FieldsTable
            }
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.fields.rows = newValue;
            this.updatePagination(this.tables.fields.page);
        },
        updatePagination(newValue){
            this.tables.fields.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"fields", 
                url:'/fields',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.fields.loading = false;
            this.updatePageLoading(false);
        },
        async deleteField(uuid){
            await this.deleteData({
                url: "/fields/" + uuid,
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                }
            });
            await this.updateData();
        } 
    },
    async mounted(){
        await this.updateData();
    }
}
</script>

<style scoped lang="scss">
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>